import { api } from './api'
import type {
  Opportunity,
  OpportunityFilters,
  OpportunityListParams,
  PaginatedOpportunities,
} from '@/types/opportunities'

export const opportunitiesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getOpportunityFilters: builder.query<{ data: OpportunityFilters }, void>({
      query: () => '/opportunities/filters',
    }),

    listOpportunities: builder.query<PaginatedOpportunities, OpportunityListParams>({
      query: (params) => {
        const search = new URLSearchParams()
        if (params.sector) search.set('sector', params.sector)
        if (params.country) search.set('country', params.country)
        if (params.featured) search.set('featured', 'true')
        if (params.page) search.set('page', String(params.page))
        if (params.perPage) search.set('perPage', String(params.perPage))
        return `/opportunities?${search.toString()}`
      },
      providesTags: [{ type: 'Opportunities', id: 'LIST' }],
    }),

    getOpportunity: builder.query<{ data: Opportunity }, string>({
      query: (id) => `/opportunities/${id}`,
      providesTags: (result) =>
        result ? [{ type: 'Opportunities', id: result.data.id }] : [],
    }),
  }),
})

export const {
  useGetOpportunityFiltersQuery,
  useListOpportunitiesQuery,
  useGetOpportunityQuery,
} = opportunitiesApi
